import { type MouseEvent, memo } from 'react';

import { WorkspaceAgentGuidedVariantSmartResizeBrowse } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantSmartResizeBrowse';
import { WorkspaceAgentGuidedVariantSmartResizeSearchResults } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantSmartResizeSearchResults';
import {
  WORKSPACE_AGENT_SMART_RESIZE_MAX_SIZES,
  type WorkspaceAgentSmartResizeSavedSize,
  type WorkspaceAgentSmartResizeSearchResults,
  type WorkspaceAgentSmartResizeSize,
  type WorkspaceAgentSmartResizeSizeSet,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentSmartResize';

export type WorkspaceAgentGuidedVariantSmartResizeMenuProps = {
  expandedGroups: ReadonlySet<string>;
  hasSearch: boolean;
  hasSearchResults: boolean;
  isAtCap: boolean;
  isExactMode: boolean;
  isSavedCatalogLoading: boolean;
  listId: string;
  onAddTyped: () => void;
  onExactSize: () => void;
  onSelectSet: (event: MouseEvent<HTMLButtonElement>) => void;
  onSelectSize: (event: MouseEvent<HTMLButtonElement>) => void;
  onToggleGroup: (event: MouseEvent<HTMLButtonElement>) => void;
  savedSets: readonly WorkspaceAgentSmartResizeSizeSet[];
  savedSizes: readonly WorkspaceAgentSmartResizeSavedSize[];
  search: WorkspaceAgentSmartResizeSearchResults;
  sizes: readonly WorkspaceAgentSmartResizeSize[];
};

export const WorkspaceAgentGuidedVariantSmartResizeMenu = memo(
  ({
    expandedGroups,
    hasSearch,
    hasSearchResults,
    isAtCap,
    isExactMode,
    isSavedCatalogLoading,
    listId,
    onAddTyped,
    onExactSize,
    onSelectSet,
    onSelectSize,
    onToggleGroup,
    savedSets,
    savedSizes,
    search,
    sizes,
  }: WorkspaceAgentGuidedVariantSmartResizeMenuProps) => (
    <>
      {isAtCap ? (
        <p className="px-2 pt-3 pb-1.5 ads:text-metadata text-12 text-gray-9">
          Up to {WORKSPACE_AGENT_SMART_RESIZE_MAX_SIZES} sizes. Remove one to add another.
        </p>
      ) : null}
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-2 py-2" id={listId}>
        {hasSearch ? (
          <WorkspaceAgentGuidedVariantSmartResizeSearchResults
            hasSearchResults={hasSearchResults}
            onAddTyped={onAddTyped}
            onSelectSet={onSelectSet}
            onSelectSize={onSelectSize}
            search={search}
            sizes={sizes}
          />
        ) : (
          <WorkspaceAgentGuidedVariantSmartResizeBrowse
            expandedGroups={expandedGroups}
            isExactMode={isExactMode}
            isSavedCatalogLoading={isSavedCatalogLoading}
            onExactSize={onExactSize}
            onSelectSet={onSelectSet}
            onSelectSize={onSelectSize}
            onToggleGroup={onToggleGroup}
            savedSets={savedSets}
            savedSizes={savedSizes}
            sizes={sizes}
          />
        )}
      </div>
    </>
  ),
);

WorkspaceAgentGuidedVariantSmartResizeMenu.displayName = 'WorkspaceAgentGuidedVariantSmartResizeMenu';
